import React from "react";
import { t } from "ttag";

import { FormView } from "../FormView";
import { ICustomerDetails } from "../models";

interface IProps {
    customer: ICustomerDetails;
}

export const CustomerDetailsEdit = (props: IProps) => {
    return (
        <FormView
            url={props.customer.url}
            baseURL={"/api/csr/users/"}
            fields={[
                {
                    label: t`Username`,
                    name: "username",
                    isRequired: true,
                    type: "text",
                },
                {
                    label: t`First Name`,
                    name: "first_name",
                    placeholder: "",
                    isRequired: false,
                    type: "text",
                },
                {
                    label: t`Last Name`,
                    name: "last_name",
                    placeholder: "",
                    isRequired: false,
                    type: "text",
                },
                {
                    label: t`Email Address`,
                    name: "email",
                    placeholder: "",
                    type: "email",
                },
            ]}
            initialValues={props.customer}
        />
    );
};
